<script>
    export default {
        
    }
</script>

<template>
    <div class="card card--imagelink is-flex is-flex-direction-column">
        <figure class="card-image is-clipped is-skeleton">
            <img alt="Loading" src="https://placehold.co/397x298?text= ">
        </figure>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column px-0 py-3">
            <div class="mb-3 mr-6"><progress class="progress is-small is-grey" max="100"></progress></div>
            <h3 class="title is-6"><progress class="progress is-grey" max="100"></progress></h3>
        </div>
    </div>
</template>
